import { render } from "./ContactView.vue?vue&type=template&id=08a9a470&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=08a9a470&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a9a470"]])

export default __exports__